import {
  EditWrapper,
  Heading3,
  Heading4,
} from '../../../../../../app/components';
import { CpfCnpjIcon } from '../../../../../../app/components/Icons';
import {
  ACCOUNT_TYPE_OBJECT,
  BANK_LIST_OBJECT,
  formatCNPJ,
  formatCPF,
} from '../../../../../../app/helpers';
import { TRegisterBusinessDataRequest } from '../../../../context';
import { useTheme } from '@mui/material';
import {
  LegalPersonViewBankContent,
  LegalPersonViewBankIcon,
  LegalPersonViewBankBox,
  LegalPersonViewBankIndex,
  LegalPersonViewBoxContainer,
  LegalPersonViewPageSection,
} from './styles';
import { PixType } from '../../../../context/CustomerProvider/customer.interfaces';
import { useState } from 'react';
import LegalPersonEditBankSection from './LegalPersonEditBankSection';
import LegalPersonEditPixSection from './LegalPersonEditPixSection';
import { EAccountPermissions } from 'modules/auth/context/permify/permify.interfaces';

type ILegalPersonViewBankSectionProps = {
  business: TRegisterBusinessDataRequest;
};

const PixTypeDescription = {
  [PixType.ALEATORY_KEY]: 'Chave aleatória',
  [PixType.EMAIL]: 'Email',
  [PixType.PHONE_NUMBER]: 'Celular',
  [PixType.TAXPAYER_ID]: 'CPF/CNPJ',
};

const LegalPersonViewBankSection = ({
  business,
}: ILegalPersonViewBankSectionProps) => {
  const { external_bank_account, pix } = business;
  const theme = useTheme();
  const [isBankEditOpen, setIsBankEditOpen] = useState(false);
  const [isPixEditOpen, setIsPixEditOpen] = useState(false);
  return (
    <>
      <LegalPersonViewPageSection>
        <Heading3
          style={{ color: theme.palette.brand.secondary.base as string }}
        >
          Dados bancários
        </Heading3>

        <LegalPersonViewBankBox>
          <Heading4
            fontWeight="B"
            style={{ color: theme.palette.brand.primary.base }}
          >
            Conta
          </Heading4>
          <EditWrapper
            handleClick={() => setIsBankEditOpen(true)}
            permission={EAccountPermissions.UPDATE_PERSON_BUSINESS}
          >
            <LegalPersonViewBoxContainer>
              {external_bank_account ? (
                <>
                  <LegalPersonViewBankIndex>01</LegalPersonViewBankIndex>
                  <LegalPersonViewBankContent>
                    <span
                      style={{
                        fontWeight: 'bold',
                        display: 'block',
                      }}
                    >{`${
                      external_bank_account?.ispb_code
                        ? BANK_LIST_OBJECT[external_bank_account.ispb_code]
                        : 'Banco não informado'
                    }`}</span>
                    <span
                      style={{
                        display: 'block',
                      }}
                    >{`Agência ${external_bank_account.bank_branch} - Conta ${external_bank_account.bank_account}-${external_bank_account.bank_account_digit}`}</span>
                    <span
                      style={{
                        display: 'block',
                      }}
                    >{`Tipo ${
                      external_bank_account?.bank_account_type
                        ? ACCOUNT_TYPE_OBJECT[
                            external_bank_account.bank_account_type
                          ]
                        : 'não informado'
                    }`}</span>
                  </LegalPersonViewBankContent>
                </>
              ) : (
                <span style={{ color: theme.palette?.brand?.gray[600] }}>
                  -
                </span>
              )}
            </LegalPersonViewBoxContainer>
          </EditWrapper>
        </LegalPersonViewBankBox>
        <LegalPersonViewBankBox>
          <Heading4
            fontWeight="B"
            style={{ color: theme.palette.brand.primary.base }}
          >
            Pix
          </Heading4>
          <EditWrapper
            handleClick={() => setIsPixEditOpen(true)}
            permission={EAccountPermissions.UPDATE_PERSON_BUSINESS}
          >
            <LegalPersonViewBoxContainer>
              {pix ? (
                <>
                  <LegalPersonViewBankIcon>
                    <CpfCnpjIcon
                      color={theme.palette.brand.secondary.base as string}
                    />
                  </LegalPersonViewBankIcon>
                  <LegalPersonViewBankContent>
                    <span
                      style={{
                        fontWeight: 'bold',
                        display: 'block',
                      }}
                    >{`${PixTypeDescription[pix.key_type]}`}</span>
                    <span
                      style={{
                        display: 'block',
                      }}
                    >
                      {pix.key_type === PixType.TAXPAYER_ID
                        ? pix.key.length > 11
                          ? formatCNPJ(pix.key)
                          : formatCPF(pix.key)
                        : pix.key}
                    </span>
                  </LegalPersonViewBankContent>
                </>
              ) : (
                <span style={{ color: theme.palette?.brand?.gray[600] }}>
                  -
                </span>
              )}
            </LegalPersonViewBoxContainer>
          </EditWrapper>
        </LegalPersonViewBankBox>
      </LegalPersonViewPageSection>
      <LegalPersonEditBankSection
        isOpen={isBankEditOpen}
        handleClose={() => setIsBankEditOpen(false)}
        business={business}
      />
      <LegalPersonEditPixSection
        isOpen={isPixEditOpen}
        handleClose={() => setIsPixEditOpen(false)}
        business={business}
      />
    </>
  );
};

export default LegalPersonViewBankSection;
